import { usePageBySlug } from "@/hooks/usePagesDB";
import StaticPageRenderer from "@/components/feature/StaticPageRenderer";
import NotFound from "../NotFound";

export default function CookiePage() {
  const { page } = usePageBySlug("cookie-richtlinie");
  if (!page) return null;
  if (!page.isPublished) return <NotFound />;

  return <StaticPageRenderer page={page} />;
}